<!--
  Route-fork PR-R1: PublicLayout.

  Minimal chrome for unauthenticated surfaces: /login, /pricing,
  /password_reset/:id, /new-user/:id, /sign-up/:id, the 404 page.
  No sidebar, no top bar (the login page renders its own ThreadFlow logo).
  The 5 routes the orchestrator wires set meta.layout='public'; everything
  else without a meta.layout also defaults to this layout via App.vue's
  fallback.
-->
<template>
    <div class="public-layout" data-testid="public-root">
        <slot />
    </div>
</template>

<script>
export default { name: "PublicLayout" };
</script>

<style scoped>
.public-layout {
    /* Fixed-viewport pattern -- see DistributorLayout for the full
     * rationale. App.vue clamps html/body/.v-application to the viewport
     * and disables document scroll, so any layout shell that doesn't
     * provide its own internal scroller silently clips tall content.
     * The five public surfaces (/login, /pricing, /password_reset/:id,
     * /new-user/:id, /sign-up/:id) range from short (login) to wizard-
     * tall (signup), so the layout itself needs to be the scroller. */
    height: 100%;
    overflow-y: auto;
    background-color: white;
}
</style>
